import type { ApiModuleEndpoints } from '../types'

export const priceApiEndpoints = {
  list: {
    method: 'GET',
    path: '/price-lists',
    requiresAuth: true,
  },
  active: {
    method: 'GET',
    path: '/price-lists/active',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/price-lists/:id',
    requiresAuth: true,
  },
  create: {
    method: 'POST',
    path: '/price-lists',
    requiresAuth: true,
  },
  update: {
    method: 'PUT',
    path: '/price-lists/:id',
    requiresAuth: true,
  },
  delete: {
    method: 'DELETE',
    path: '/price-lists/:id',
    requiresAuth: true,
  },
  products: {
    method: 'GET',
    path: '/price-lists/:id/products',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
